import React from 'react';
export function IntroContent() {
  return <div className="w-full pt-12 md:pt-16" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2786">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-2787">
        <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border" style={{
        borderColor: '#ede9e0'
      }} data-id="element-2788">
          <p className="text-base text-gray-800 leading-relaxed mb-4" style={{
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-2789">
            This privacy notice discloses the privacy practices for
            FentonLakes.com. This privacy notice applies solely to information
            collected by this website. It will notify you of the following:
          </p>
          <ol className="space-y-2 ml-1" data-id="element-2790">
            <li className="flex items-start gap-3" data-id="element-2791">
              <span className="w-6 h-6 rounded flex items-center justify-center flex-shrink-0 mt-0.5 text-xs font-bold" style={{
              backgroundColor: 'rgba(30,61,47,0.08)',
              color: '#1e3d2f',
              fontFamily: 'Oswald, sans-serif'
            }} data-id="element-2792">
                1
              </span>
              <span className="text-base text-gray-800" style={{
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-2793">
                What personally identifiable information is collected from you
                through the website, how it is used and with whom it may be
                shared.
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-2794">
              <span className="w-6 h-6 rounded flex items-center justify-center flex-shrink-0 mt-0.5 text-xs font-bold" style={{
              backgroundColor: 'rgba(30,61,47,0.08)',
              color: '#1e3d2f',
              fontFamily: 'Oswald, sans-serif'
            }} data-id="element-2795">
                2
              </span>
              <span className="text-base text-gray-800" style={{
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-2796">
                What choices are available to you regarding the use of your
                data.
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-2797">
              <span className="w-6 h-6 rounded flex items-center justify-center flex-shrink-0 mt-0.5 text-xs font-bold" style={{
              backgroundColor: 'rgba(30,61,47,0.08)',
              color: '#1e3d2f',
              fontFamily: 'Oswald, sans-serif'
            }} data-id="element-2798">
                3
              </span>
              <span className="text-base text-gray-800" style={{
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-2799">
                The security procedures in place to protect the misuse of your
                information.
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-2800">
              <span className="w-6 h-6 rounded flex items-center justify-center flex-shrink-0 mt-0.5 text-xs font-bold" style={{
              backgroundColor: 'rgba(30,61,47,0.08)',
              color: '#1e3d2f',
              fontFamily: 'Oswald, sans-serif'
            }} data-id="element-2801">
                4
              </span>
              <span className="text-base text-gray-800" style={{
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-2802">
                How you can correct any inaccuracies in the information.
              </span>
            </li>
          </ol>
        </div>
      </div>
    </div>;
}